import type { Content } from '@lumapps/contents/types';

/**
 * Builds the content update payload for new start/end dates, setting both the ISO dates
 * and the legacy date inputs (date + hour + minutes) expected by the save API.
 */
export const getContentDatesUpdate = ({
    startDate,
    endDate,
}: {
    startDate?: string;
    endDate?: string;
}): Partial<Content> => {
    const startDateAsDate = startDate ? new Date(startDate) : undefined;
    const endDateAsDate = endDate ? new Date(endDate) : undefined;

    return {
        startDate,
        endDate,
        startDateInput: {
            date: startDate,
            hour: startDateAsDate && startDateAsDate.getHours(),
            min: startDateAsDate && startDateAsDate.getMinutes(),
        },
        endDateInput: {
            date: endDate,
            hour: endDateAsDate && endDateAsDate.getHours(),
            min: endDateAsDate && endDateAsDate.getMinutes(),
        },
    };
};
